import LinkList from './LinkList';

export default LinkList;
